(function () {
  'use strict';

  var filterBar = document.getElementById('filter-bar');
  var grid = document.getElementById('design-grid');
  if (!filterBar || !grid) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('.hz-shop-item'));

  function applyFilter(cat) {
    filterBar.querySelectorAll('.hz-shop-filter').forEach(function (btn) {
      var active = btn.dataset.cat === cat;
      btn.style.background = active ? '#A794DD' : '#fff';
      btn.style.color = active ? '#FBF1E3' : '#4A3B36';
    });

    items.forEach(function (item) {
      if (cat === 'All') {
        item.style.display = '';
        return;
      }
      var tags = (item.dataset.tags || '').split(',').map(function (t) { return t.trim().toLowerCase(); });
      item.style.display = tags.indexOf(cat.toLowerCase()) !== -1 ? '' : 'none';
    });
  }

  filterBar.querySelectorAll('.hz-shop-filter').forEach(function (btn) {
    btn.addEventListener('click', function () { applyFilter(btn.dataset.cat); });
  });
})();
